import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import moment from "moment";
import CustomAccordion from "./CustomAccordion";
import Box from "@mui/material/Box";

const CustomTimeline = ({items} : any) => {
    return (
        <Timeline
            sx={{
            [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
            },
        }}>
            {items.map((item: any, index: any) => (
                <TimelineItem key={index}>
                    <TimelineSeparator>
                        <TimelineDot sx={{
                            backgroundColor: item.dotColor ? item.dotColor : "primary.main",
                        }}/>
                        {index !== items.length - 1 && <TimelineConnector />}
                    </TimelineSeparator>
                    <TimelineContent>
                        <Box display="flex" alignItems="center" mb={1}>
                            {item.date && (
                                <Box
                                    mr={{xs: 1.5, sm: 3}}
                                    sx={{
                                        width: "auto",
                                        flexShrink: 0,
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography variant="h5" sx={{
                                        fontWeight: 400,
                                        color: "primary.main"
                                    }}>
                                        {moment(item.date).locale("ro").format("HH:mm:ss")}
                                    </Typography>
                                    <Typography variant="body2" sx={{fontWeight: 400}}>
                                        {moment(item.date).locale("ro").format("DD-MM-YYYY")}
                                    </Typography>
                                </Box>
                            )}
                            <Typography variant="h4" sx={{color: item.dotColor}}>
                                {item.title}
                            </Typography>
                        </Box>
                        {item.item &&  <CustomAccordion data={[item.item]} />}
                    </TimelineContent>
                </TimelineItem>
            ))}
        </Timeline>
    )
}

export default CustomTimeline;